export default __webpack_public_path__ + "static/media/roofing-felt.4244c9da.svg";